import { ApiButton, Button, SvgButton } from '@coursera/coursera-ui';

import withSingleTracked from 'bundles/common/components/withSingleTracked';

export const TrackedButton = withSingleTracked({ type: 'BUTTON' })(Button);
export const TrackedSvgButton = withSingleTracked({ type: 'BUTTON' })(SvgButton);
export const TrackedApiButton = withSingleTracked({ type: 'BUTTON' })(ApiButton);
